<template>
  <div class="full-screen-loading-spinner">
    <loading-spinner size="100px"></loading-spinner>
  </div>
</template>

<script>
import LoadingSpinner from './loading-spinner';

export default {
  name: 'FullScreenLoadingSpinner',
  components: {
    LoadingSpinner
  }
};
</script>

<style lang="scss" scoped>
  .full-screen-loading-spinner {
    z-index: 1000;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100%;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/full-screen-loading-spinner.vue